// Debug-Konsole-Steuerung für die Browser-Konsole
// Einfach in der Browser-Konsole eingeben:
// debug.help() - zeigt alle verfügbaren Befehle
// debug.on() - aktiviert alle Debug-Modi
// debug.off() - deaktiviert alle Debug-Modi

import {
  DEBUG_CONFIG,
  disableAllDebug,
  enableAllDebug,
  toggleDebugMode,
} from "./debug";

// Globale Debug-Steuerung für die Browser-Konsole
const debugConsole = {
  // Zeigt den aktuellen Debug-Status
  status: () => {
    console.log("🔧 Debug-Status:", {
      "Haupt-Modus": DEBUG_CONFIG.DEBUG_MODE ? "AN" : "AUS",
      "Auth-Debug": DEBUG_CONFIG.AUTH_DEBUG ? "AN" : "AUS",
      "Video-Debug": DEBUG_CONFIG.VIDEO_DEBUG ? "AN" : "AUS",
      "API-Debug": DEBUG_CONFIG.API_DEBUG ? "AN" : "AUS",
      "Workshop-Debug": DEBUG_CONFIG.WORKSHOP_DEBUG ? "AN" : "AUS",
      "Performance-Debug": DEBUG_CONFIG.PERFORMANCE_DEBUG ? "AN" : "AUS",
      "Error-Logging": DEBUG_CONFIG.ERROR_LOGGING ? "AN" : "AUS",
    });
  },

  // Aktiviert alle Debug-Modi
  on: () => {
    enableAllDebug();
    debugConsole.status();
  },

  // Deaktiviert alle Debug-Modi
  off: () => {
    disableAllDebug();
    debugConsole.status();
  },

  // Toggle Haupt-Debug-Modus
  toggle: () => {
    toggleDebugMode();
    debugConsole.status();
  },

  // Spezifische Debug-Modi
  auth: (enabled: boolean = true) => {
    (DEBUG_CONFIG as any).AUTH_DEBUG = enabled;
    console.log(`🔐 Auth-Debug: ${enabled ? "AN" : "AUS"}`);
  },

  video: (enabled: boolean = true) => {
    (DEBUG_CONFIG as any).VIDEO_DEBUG = enabled;
    console.log(`🎬 Video-Debug: ${enabled ? "AN" : "AUS"}`);
  },

  api: (enabled: boolean = true) => {
    (DEBUG_CONFIG as any).API_DEBUG = enabled;
    console.log(`🌐 API-Debug: ${enabled ? "AN" : "AUS"}`);
  },

  workshop: (enabled: boolean = true) => {
    (DEBUG_CONFIG as any).WORKSHOP_DEBUG = enabled;
    console.log(`💃 Workshop-Debug: ${enabled ? "AN" : "AUS"}`);
  },

  perf: (enabled: boolean = true) => {
    (DEBUG_CONFIG as any).PERFORMANCE_DEBUG = enabled;
    console.log(`⚡ Performance-Debug: ${enabled ? "AN" : "AUS"}`);
  },

  // Zeigt alle verfügbaren Befehle
  help: () => {
    console.log(`
🔧 Debug-Konsole Befehle:

debug.status()     - Zeigt aktuellen Debug-Status
debug.on()         - Aktiviert alle Debug-Modi
debug.off()        - Deaktiviert alle Debug-Modi
debug.toggle()     - Toggle Haupt-Debug-Modus

Spezifische Modi:
debug.auth(true)   - Auth-Debug aktivieren
debug.video(true)  - Video-Debug aktivieren
debug.api(true)    - API-Debug aktivieren
debug.workshop(true) - Workshop-Debug aktivieren
debug.perf(true)   - Performance-Debug aktivieren

Session-Management:
debug.logoutAll()  - Beendet alle Supabase-Sessions
debug.clearData()  - Löscht alle lokalen Daten

Beispiele:
debug.auth()       - Auth-Debug aktivieren
debug.video(false) - Video-Debug deaktivieren
debug.workshop()   - Workshop-Debug aktivieren
debug.logoutAll()  - Alle Sessions beenden

Alle Befehle geben den aktuellen Status aus.
    `);
  },

  // Supabase-Sessions beenden
  logoutAll: async () => {
    console.log("🔐 Beende alle Supabase-Sessions...");

    try {
      // Importiere Supabase Client
      const { supabase } = await import("../integrations/supabase/client");

      // Logout aus aktueller Session
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error("❌ Fehler beim Logout:", error);
      } else {
        console.log("✅ Erfolgreich ausgeloggt");
      }

      // Alle lokalen Daten löschen
      localStorage.clear();
      sessionStorage.clear();
      console.log("✅ Alle Sessions und Daten gelöscht");

      // Seite neu laden
      window.location.reload();
    } catch (error) {
      console.error("❌ Fehler beim Beenden der Sessions:", error);
    }
  },

  // Alle lokalen Daten löschen
  clearData: () => {
    console.log("🧹 Lösche alle lokalen Daten...");
    localStorage.clear();
    sessionStorage.clear();
    console.log("✅ Alle lokalen Daten gelöscht");
  },
};

// Mache debug global verfügbar
if (typeof window !== "undefined") {
  (window as any).debug = debugConsole;

  // Debug-Log beim Laden deaktiviert (war: Hinweis auf debug.help())
  // console.log("🔧 Debug-Konsole geladen! Tippe \"debug.help()\" für alle Befehle.");
}

export { debugConsole };
